exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar,[class*=\" navbar-\"],[class^=navbar-]{box-sizing:border-box}.navbar-inner{position:fixed;left:0;right:0}.navbar-limited{position:relative;min-width:1080px;max-width:1320px;margin-left:auto;margin-right:auto;padding-left:20px;padding-right:20px}.navbar-notif.alert{border-left:none;border-right:none;padding:6px 0}.navbar-notif-cancelable{display:flex;justify-content:space-between}", ""]);

// exports
